import { AddUsersIcon, ContextMenu, InboxIcon } from "@rothoblaas/design-system";
import { FC } from "react";
import useI18n from "../hooks/useTranslations";
import { NotificationEntry } from "../utils/notifications";
import { BellIcon } from "./ds2/icons";
import Icon from "./ui/Icon";
import styles from "./NotificationBell.module.css";

// a longer count would not fit in the badge
const MAX_COUNT = 9;

interface NotificationBellProps {
  entries: NotificationEntry[];
  onSelect: (path: string) => void;
}

/** The nav bar bell, only while something waits for the user: its menu lists it, each entry opening its page */
const NotificationBell: FC<NotificationBellProps> = ({ entries, onSelect }) => {
  const i18n = useI18n();

  if (!entries.length) {
    return null;
  }

  return (
    <ContextMenu
      locale={i18n.translation.languageCode}
      triggerLabel={i18n.translation.notifications.title}
      trigger={
        <span className={styles.bell}>
          <BellIcon />
          <span className={styles.count}>{entries.length > MAX_COUNT ? `${MAX_COUNT}+` : entries.length}</span>
        </span>
      }
      items={entries.map((entry) => ({
        label: entry.label,
        icon: <Icon glyph={entry.isInvite ? InboxIcon : AddUsersIcon} />,
        onClick: () => onSelect(entry.path),
      }))}
    />
  );
};

export default NotificationBell;
